import { Container } from '@tencent/alloy-renderer';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import {
    InterfaceFactoryOptions,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import {
    ElementBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/element-base-component';

export class TableBackgroundFillComponent extends Container {
    public factoryOptions: InterfaceFactoryOptions<ITableModel>;
    private model: ITableModel;
    private backgroundComponent: ElementBaseComponent | undefined;

    public constructor(factoryOptions: InterfaceFactoryOptions<ITableModel>) {
        super();
        this.factoryOptions = factoryOptions;
        this.updateComponent();
    }

    public updateModel(model: ITableModel): void {
        this.model = model;
        this.updateComponent();
    }

    private updateComponent(): void {
        if (!this.model?.props?.style?.fillBackground) {
            if (this.backgroundComponent) {
                this.removeChild(this.backgroundComponent);
                this.backgroundComponent = undefined;
            }
            return;
        }

        if (!this.backgroundComponent) {
            this.backgroundComponent = new ElementBaseComponent(this.factoryOptions);
        }

        if (!this.children.includes(this.backgroundComponent)) {
            this.addChildAt(this.backgroundComponent, 0);
        }

        this.backgroundComponent?.renderComponent();
    }
}
